import React from 'react';
import Loader from 'components/Elements/Loader/Loader';
import { UserSession } from 'types';
import useUserStore from 'store/useUserStore';

export default function UserSessionProvider({
  children,
}: {
  children: ({ user }: { user: UserSession }) => React.ReactNode;
}) {
  // fetch profile data from store
  const user = useUserStore(s => s.user);

  if (user) {
    return <div>{children({ user })}</div>;
  }

  return <Loader isVisible fullscreen={false} theme="dark" />;
}
